import React from "react";
import { Redirect } from "react-router-dom";

import { ErrorPage } from "@/ErrorPage";
import { CroSplashLoadingPlaceholder } from "@/splash/CroSplashLoadingPlaceholder";
import { useCroFeatureAccess } from "@/hooks/useCroFeatureAccess";
import type { CroFeature } from "@/types/croFeature";

// Keep in sync with the route registrations in App.tsx.
const FEATURE_ROOT_PATH: Record<CroFeature, string> = {
  ai_chat: "/ai-chat",
  web_analytics: "/web-analytics",
  funnels: "/funnels",
  heatmaps: "/heatmaps",
  session_replay: "/session-replay",
  surveys: "/surveys",
};

export interface CroFeatureChildRouteGuardProps {
  feature: CroFeature;
  children: React.ReactNode;
}

export function CroFeatureChildRouteGuard({
  feature,
  children,
}: CroFeatureChildRouteGuardProps) {
  const access = useCroFeatureAccess(feature);

  switch (access.state) {
    case "loading":
      return <CroSplashLoadingPlaceholder />;
    case "coming-soon":
      return <ErrorPage />;
    case "no-permissions":
    case "needs-ai-consent":
    case "get-started":
      return <Redirect to={FEATURE_ROOT_PATH[feature]} />;
    case "feature":
      return <>{children}</>;
  }
}
